<div class="alert alert-success" *ngIf="notificationSuccess">
  Chapter Notification sent successfully!
</div>
<div class="alert alert-danger" *ngIf="notificationFailure">
  {{errorMsg}} !
</div>
<div class="alert alert-success" *ngIf="copySuccess">
  Emails Copied to ClipBoard!
</div>
<div class="alert alert-danger" *ngIf="noMemberFound">
  No Chapter Member Found!
</div>
<div class="common-padding">
  <div class="col-md-12 col-xs-12 col-sm-12 heading p-0 mt-3 mb-4 d-flex justify-content-between">
    <div>
      <span class="span-create-edit-hoshin color">PUSH NOTIFICATION</span>
      <span class="pt-2" style="font-size: 13px;">
        <a href="assets/userguides/PushNotificationUserGuide.pdf" download class="pl-3 download-link">User Guide</a>
      </span>
    </div>
    <span class="advanced-filter" (click)="showJoinedDateFilter()">Filter by Joined Date</span>
  </div>
  
  <form class="admin-font-style" (ngSubmit)="sendNotification()" action="" name="notificationForm"
    #notificationForm="ngForm" enctype="multipart/form-data">
    <div>
      <div class="col-md-6 inlineFlex leftFloat zeroLeftPad">
        <label class="col-md-3 zeroLeftPad">Select BPG<span class="star"> *</span></label>
        <ng-select placeholder="--Select BPG--" class="col-md-9" [items]="bpgList" name="bpgName" bindLabel="bpgName"
          bindValue="bpgId" [(ngModel)]="bpgId" (change)="bpgChange($event)" required>
          <ng-template ng-option-tmp let-item="item">
            <div title="{{item.bpgName}}">{{item.bpgName}}</div>
          </ng-template>
        </ng-select>
      </div>
      <div class="col-md-6 inlineFlex inlineFlex zeroRightPad">
        <span class="divide-width"></span>
        <label class="col-md-3 " for="docName">Select Site<span class="star"> *</span></label>
        <ng-select placeholder="--Select Site--" class="col-md-8 zeroRightPad" [items]="siteList" name="siteName"
          bindLabel="siteName" [multiple]="true" (change)="siteChange($event)" [(ngModel)]="siteId" required>
          <ng-template ng-option-tmp let-item="item">
            <div title="{{item.siteName}}">{{item.siteName}}</div>
          </ng-template>
        </ng-select>
      </div>
      <div class="col-md-9 inlineFlex  leftFloat zeroLeftPad" *ngIf="showJoinedDateField">
        <label class="col-md-2 zeroLeftPad">Filter By Joined Date<span class="star"> *</span></label>
        <ng-select placeholder="--Select By--" class="col-md-6" [items]="filterList" name="filterName"
          bindLabel="filterName" bindValue="filterId" [(ngModel)]="selectedFilter" (change)="getChapterMembersEmails()"
          required>

        </ng-select>
      </div>
      <div class="col-md-6 inlineFlex leftFloat zeroLeftPad" *ngIf="showCustomDateRange && showJoinedDateField">
        <label class="col-md-3 zeroLeftPad">Start Date<span class="star"> *</span></label>
        <input type="text" placeholder="  --Start Date--" style="padding-left:7px"
          class="form-control col-md-9 date-icon" bsDatepicker [(ngModel)]="startDate" name="startDate"
          [maxDate]="todaysDate" (ngModelChange)="getChapterMembersEmails()" [bsConfig]="{ isAnimated: true }">
      </div>
      <div class="col-md-6 inlineFlex inlineFlex zeroRightPad" *ngIf="showCustomDateRange && showJoinedDateField">
        <span class="divide-width"></span>
        <label class="col-md-3 " for="docName">End Date<span class="star"> *</span></label>
        <input type="text" placeholder="  --End Date--" style="padding-left:7px"
          class="form-control col-md-8 zeroRightPad date-icon" bsDatepicker [(ngModel)]="endDate" name="endDate"
          [maxDate]="todaysDate" (ngModelChange)="getChapterMembersEmails()" [bsConfig]="{ isAnimated: true }">
      </div>
      <div class="col-md-9 inlineFlex  leftFloat zeroLeftPad">



        <!-- <span class="divide-width"></span> -->

        <label class="col-md-2 zeroLeftPad">To<span class="star"> *</span></label>

        <ng-select placeholder="--Select Email--" class="form-control col-md-10 scroll-height" [searchable]="false"
          [items]="emailList" name="emailId" bindLabel="emailId" bindValue="emailId" [multiple]="true"
          (change)="emailChange($event)" [(ngModel)]="selectedEmail" required></ng-select>
        <div class="col-md-3 inlineFlex mt-3 zeroRightPad">


          <button class="btn btn-danger" (click)="copyText()" *ngIf="selectedEmail.length > 0">Copy to Clipboard</button>&nbsp;&nbsp;
          <!-- <button class="btn btn-danger" (click)="sendEmail()" *ngIf="selectedEmail.length > 0">Send
            Email</button>&nbsp;&nbsp; -->

          <button class="btn btn-danger" (click)="openAndCloseMatDialog('open')"
            *ngIf="selectedSiteIds.length > 0">Add Members</button>&nbsp;&nbsp;
          <button class="btn btn-danger" (click)="removeText()" *ngIf="selectedEmail.length > 0">Clear</button>

        </div>
      </div>
      <div class="col-md-9 inlineFlex leftFloat zeroLeftPad">


        <label class="col-md-2 zeroLeftPad">Subject<span class="star"> *</span>
          <div class="errorMessage" style="font-size: 12px">(Max. 500 characters allowed)</div>

        </label>
        <textarea class="form-control col-md-10 zeroRightPad placeholder" id="subject" name="subject"
          placeholder="Enter Email Subject.." maxlength="500" rows="4" [(ngModel)]="subject" autocomplete="off"
          required></textarea>

      </div>
      <div class="col-md-9 inlineFlex inlineFlex zeroLeftPad">
        <!-- <span class="divide-width"></span> -->
        <label class="col-md-2 zeroLeftPad" for="docName">Email Body<span class="star"> *</span>
          <div class="errorMessage" style="font-size: 12px">(Max. 2000 characters allowed)</div>
        </label>
        <ckeditor class="ck-class col-md-10" [(ngModel)]="chapterNotification" id="chapterNotification"
          name="chapterNotification" required #myckeditor="ngModel" maxlength="500" [config]="removeToolbarHeaders"
          debounce="500"> </ckeditor>
        <!-- <textarea class="form-control col-md-10 zeroRightPad placeholder" id="chapterNotification"
          name="chapterNotification" placeholder="Use Push Notification feature , to message BPG membership..."
          maxlength="2000" rows="8" [(ngModel)]="chapterNotification" autocomplete="off" required></textarea> -->

      </div>





      <div class="col-md-6 inlineFlex  zeroLeftPad">
        <label class="col-md-3 zeroLeftPad upload-label-padding" for="UploadDocument">Upload File</label>
        <input #myInput type="file" id="UploadDocument" (change)="onFileSelected($event)" name="UploadDocument"
          placeholder="Upload" class="form-control input-lg upload-icon hideInput" [multiple]="true">
        <label class="form-control input-lg upload-icon col-md-8 width-label" for="UploadDocument"><label
            class="docNameEllipsis resource-ellipsis col-md-8 upload-file-name-class ">{{fileName}}</label>
          <p class="formats-font">( jpg, png, jpeg, pdf, ppt, pptx, txt, doc, docx, xlsx, csv )</p>


        </label>
      </div>

      <div id="tabledemo1" *ngIf="fileList.length!=0">

        <div class="table-container">
          <p class="selected-files">SELECTED FILES</p>
          <table aria-describedby="table" [ngClass]="{'table-responsive':tableresp}" class="table table-striped" id="tabledemo">
            <thead>
              <tr class="tr-th">
                <th scope="col" style="padding-left:20%">File Name</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of fileList">
                <td style="padding-left:10%">{{data.name}}</td>
                <td>
                  <a (click)="deleteFile(data)" class="edit-delete"><img src="assets/images/delete.png" class="image" alt="Angular Logo"
                      title="Delete"></a>
                </td>
              </tr>

            </tbody>
          </table>
        </div>


      </div>
    </div>
    <div class="top-space text-center col-md-12">
      <p class="errorMessage" *ngIf="fileSizeExtensionError">You can only upload the
        file of size less than 500 MB </p>
      <p class="errorMessage" *ngIf="fileExtensionError">Invalid format</p>
      <p class="errorMessage" *ngIf="chapterNotification!= null && chapterNotification.length>2000">Only a
        maximum of 2000 characters are allowed for Email Body!</p>
      <p class="errorMessage" *ngIf="startDateGreaterError">Start Date greater than End Date!</p>
      <button type="submit" id="submitButton" *ngIf="!showJoinedDateField || (showJoinedDateField && selectedFilter!=2)"
        class="btn btn-danger col-sm-2 col-md-2 style btn-width"
        [disabled]="(!notificationForm.valid || fileExtensionError || fileSizeExtensionError || selectedFilter == null || selectedFilter == undefined || chapterNotification.length>2000 || selectedEmail.length==0)"
        data-target="#myModal" data-toggle="modal">SEND NOTIFICATION</button>
      <button type="submit" id="submitButton" *ngIf="showJoinedDateField && selectedFilter==2"
        class="btn btn-danger col-sm-2 col-md-2 style btn-width"
        [disabled]="(!notificationForm.valid || fileExtensionError || startDate == null || endDate == undefined || endDate == null || startDate == undefined || startDateGreaterError || fileSizeExtensionError || chapterNotification.length>2000 ||  selectedFilter == null || selectedFilter == undefined ||  selectedEmail.length==0)"
        data-target="#myModal" data-toggle="modal">SEND NOTIFICATION</button>
      <span class="preview"></span>
      <button type="button" class="btn btn-danger col-sm-2 col-md-2 style btn-width" data-toggle="modal"
        (click)="resetClick()" data-target="#myModal">RESET</button>
    </div>
  </form>
</div>
<app-confirmation-modal [PData]="msg1" (emitPass)="this[method](param)" id="2"></app-confirmation-modal>


<ng-template #callAPIDialog>
  <div class="alert alert-danger" *ngIf="noUser">
    No user found !
  </div>
  <div class="alert alert-success" *ngIf="userFound">
    Please select from user dropdown
  </div>
  <div class="alert alert-danger" *ngIf="userExists">
    User already added!
  </div>
  <div class="alert alert-success" *ngIf="usersAdded">
    Users added successfully!
  </div>

  <!-- <span class="material-icons cursor" mat-dialog-close mat-dialog-close="true" title="Close">
    X</span> -->
  <div>
    <h5 style="font-weight: bolder;">ADD USERS</h5>
    <!-- <button class="close" mat-button
        (click)="openAndCloseMatDialog('close')">X</button>-->


  </div>
  <div class="container1 tab-pane">
    <div class="mainSection searchBy">
      <div class="search-tag"><input type="text" class="form-control width-class" maxlength="50"
          placeholder="Search by first name, last name, email id or workday id" [(ngModel)]="searchTerm">
        <button type="button" class="btn btn-danger image-search" (click)="searchBy()">SEARCH</button>

      </div>
    </div>
    <div class="form-group">
      <label class="sitelabel" for="userName">Select User<span class="star"> *</span></label>
      <ng-select placeholder="Select User" class="width-change" [items]="userList" bindLabel="userFirstName"
        [(ngModel)]="userFirstName" (change)="userSelection($event)">
          <ng-template ng-option-tmp let-item="item" let-index="index">
            <div>{{item.userFirstName}}</div>
            <div *ngIf="item.division" style="font-size: 11px">{{item.division}}</div>
            <div *ngIf="item.classification" style="font-size: 11px">{{item.classification}}</div>
          </ng-template>
      </ng-select>
    </div>
    <div class="table-container" *ngIf="selectedUserList.length>0">
      <table aria-describedby="table" [ngClass]="{'table-responsive':tableresp}" class="table table-striped" id="tabledemo">
        <thead>
          <tr class="tr-th">
            <th scope="col">Name</th>
            <th scope="col">Email ID</th>
            <th scope="col">Actions</th>

          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of selectedUserList">
            <td>{{data.userFirstName}}</td>
            <td>{{data.emailId}}</td>


            <td>

              <a class="deleteButton delete-button-style zoom-in-style" title="delete"
                (click)="removeUser(data.emailId)"><img src="assets/images/delete.png" class="image" alt="Angular Logo"></a>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="clear"></div>


    </div>
    <div class="btn-div1 alignment">
      <button (click)="addUserToList()" id="signIn" data-toggle="modal" data-target="#myModal"
        class="btn btn-danger margin-save" [disabled]="selectedUserList.length == 0">ADD</button>

      <button type="button" class="btn btn-danger margin-save" [disabled]="selectedUserList.length == 0"
        (click)="resetSelectedUser()">RESET</button>
      <button type="button" class="btn btn-danger margin-save" (click)="openAndCloseMatDialog('close')">CLOSE</button>
    </div>


  </div>

</ng-template>
